import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa8997c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fa8997c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8997c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/workspace/components/footer/index.vue').default})
